import { PoolCreateRequest } from "../../model/poolCreateRequest";
import { fetchPostJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = PoolCreateRequest;

export async function postPools(payload: DtoType) {
  try {
    const url = apiUrls.postPools;
    return await fetchPostJSON(url, payload);
  } catch (err) {
    console.error("API Error - postPools:", err);
  }
}
